<template>
  <div id="login">
    <a-layout-header class="layout-header">
      <a-row justify="end" align="middle">
        <GlobalOutlined class="ic-global" />
        <language-selector />
      </a-row>
    </a-layout-header>
    <a-layout class="layout-style">
      <a-layout-content>
        <a-row style="height: 100%; align-items: center">
          <div class="login-swiper flex-align">
            <!-- <img :src="themeData.darkLogoListWhite" class="logo"> -->
            <img :src="themeData.bgList" class="bgList">
            <div class="login_text">
              <div class="login_text_title">一键收款，畅行无阻</div>
              <img class="login_text_line" src="~@/assets/images/login_line.png">
              <div class="login_text_content">
                轻松收款全球各地，无论您的客户身在何处，只需简单操作<br>
                即可实现资金快速到账。我们的平台支持多种国际支付方式，安<br>
                全可靠，让您的跨境业务更具竞争力，资金流动无障碍。
              </div>
            </div>
          </div>
          <div class="card-box">
            <div class="card-login">
              <!-- <img :src="themeData.darkLogoList" class="form_logo"> -->

              <div class="card-title">{{ $t("pages_login_014") }}</div>
              <div class="card-body">
                <a-form :model="loginState" :rules="loginRules" class="login-form ant-round-form" @finish="loginSuccess">
                  <a-form-item name="username">
                    <div style="position: relative">
                      <a-input
                        v-model:value="loginState.username"
                        style="position: relative;height: 40px; line-height: 40px;"
                        :placeholder="$t('pages_login_002')"
                      >
                        <template #prefix>
                          <user-outlined />
                        </template>
                      </a-input>
                    <!-- <a-form-item-rest>
                      <a-select
                        v-model:value="loginState.areacode"
                        :bordered="false"
                        class="area-select"
                      >
                        <a-select-option value="+86">+86</a-select-option>
                        <a-select-option value="+87">+87</a-select-option>
                      </a-select>
                    </a-form-item-rest> -->
                    </div>
                  </a-form-item>

                  <a-form-item name="password">
                    <a-input-password v-model:value="loginState.password" :placeholder="$t('pages_login_003')" style="height: 40px; line-height: 40px;">
                      <template #prefix>
                        <LockOutlined />
                      </template>
                    </a-input-password>
                  </a-form-item>

                  <div v-if="resMsg" class="error-text">{{ resMsg }}</div>

                  <a-form-item v-if="needsCode" name="code">
                    <div class="flex-align">
                      <a-input
                        v-model:value="loginState.code"
                        style="border-radius: 3px"
                        :placeholder="$t('pages_login_008')"
                      />
                      <img class="code-src" :src="codeSrc" @click="loadValidateCode">
                    </div>
                  </a-form-item>
                  <div class="login-form-forgot">
                    <span @click="() => (sendVisible = true)">{{
                      $t("pages_login_004")
                    }}</span>
                  </div>
                  <a-form-item style="margin-top: 32px">
                    <a-button style="width: 100%;border-radius: 3px;height: 40px;" shape="round" type="primary" html-type="submit" :loading="loading">{{
                      $t("pages_login_005") }}</a-button>
                  </a-form-item>

                  <a-form-item style="text-align: center; font-size: 14px">
                    <span style="color: #999">{{ $t('pages_login_006') }}</span>
                    <span class="main-text-color" style="cursor: pointer;color: #000000;" @click="$router.push('/register')">{{
                      $t('pages_login_007')
                    }}</span>
                  </a-form-item>
                </a-form>
              </div>
            </div>
          </div>
        </a-row>
      </a-layout-content>
    </a-layout>
    <!-- <div class="keep-record">
      <div v-if="themeData.address">{{ themeData.address }}</div>
      <a target="_blank" href="https://beian.miit.gov.cn">{{
        themeData.copyRight
      }}</a>
    </div> -->
    <password-forget v-model:send-visible="sendVisible" v-model:succ-visible="succVisible" />
    <slide-verify v-model:visible="visible" @success="loginSuccess" />
  </div>
</template>
<script>
import LangSelector from '@/components/lang-sel'
import PasswordForget from './components/password-forget'
import SlideVerify from '@/components/slide-verify'
import { ref, reactive, inject, defineComponent } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { _login } from '@/api'
import { getIdentyImg } from '@/util'
import i18n from '@/locale'
export default defineComponent({
  name: 'Login',
  components: {
    'password-forget': PasswordForget,
    'slide-verify': SlideVerify,
    'language-selector': LangSelector
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    const resMsg = ref('')
    const needsCode = ref(false)
    const codeSrc = ref('')
    const sendVisible = ref(false)
    const succVisible = ref(false)
    const loading = ref(false)
    const visible = ref(false)

    const themeData = inject('$themeData')

    const loginState = reactive({
      areacode: '+86',
      username: '',
      password: '',
      code: ''
    })

    const loginRules = {
      username: [
        {
          required: true,
          trigger: 'change',
          message: i18n.global.t('pages_login_002')
        }
      ],
      password: [
        {
          required: true,
          trigger: 'change',
          message: i18n.global.t('pages_login_003')
        }
      ],
      code: [
        {
          required: true,
          trigger: 'change',
          message: i18n.global.t('pages_login_008')
        }
      ]
    }

    const loginSuccess = async (e) => {
      resMsg.value = ''
      loading.value = true
      visible.value = false
      const data = {
        userName: loginState.username,
        password: loginState.password,
        code: loginState.code
      }
      if (e.sliderFlag) data.sliderFlag = e.sliderFlag
      try {
        const res = await _login.login(data)
        if (res.data.succ) {
          succDeal(res.data.data)
        } else {
          loading.value = false
          resMsg.value = res.data.resMsg
          if (['010001', '010006'].includes(res.data.resCode)) {
            needsCode.value = true
            loadValidateCode()
          }
        }
      } catch (e) {
        console.log(e)
        loading.value = false
      }
    }

    const loadValidateCode = () => {
      loginState.code = ''
      codeSrc.value = getIdentyImg(loginState.username)
    }

    const succDeal = async (data) => {
      const {
        menuList,
        userInfo,
        status,
        authFlag,
        activityStatus,
        entrySliderFlag
      } = data
      if (entrySliderFlag) {
        visible.value = true
        loading.value = false
      } else if (authFlag) {
        userInfo.status = status
        store.commit('updateMenuList', menuList)
        store.commit('updateUserInfo', userInfo)
        if (userInfo.mobile) {
          localStorage.setItem('mobileStatus', true)
          router.push('/home/index')
        } else {
          router.push('/user/account_materials')
        }
        await store.dispatch('getLanguage')
        loading.value = false
      } else {
        if (activityStatus === '40') {
          router.push('/guide_success')
        }
      }
    }

    const init = () => {
      if (route.query.source) {
        localStorage.setItem('Authorization', route.query.token)
        _login
          .loginCheck()
          .then((res) => {
            if (res.data.succ) succDeal(res.data.data)
          })
          .catch((err) => console.log(err))
      }
    }

    init()

    return {
      themeData,
      resMsg,
      needsCode,
      codeSrc,
      loading,
      visible,
      sendVisible,
      succVisible,
      loginState,
      loginRules,
      loginSuccess,
      loadValidateCode
    }
  }
})
</script>
<style lang="less" scoped>
#login {
  .scrollbar-none;
  background: #f8f9fb;
  height: 100vh;
  overflow-y: scroll;

  .ic-global {
    color: @main-color;
  }

  .layout-header {
    background: #f8f9fb;
    position: absolute;
    top: 6%;
    right: 100px;
  }

  .login-swiper {
    height: 100%;
    align-items: flex-start;
    position: relative;
    width: 52%;

    .logo {
      position: absolute;
      width: 184px;
      top: 40px;
      left: 100px;
    }

    .bgList {
      width: 100%;
      height: 100%;
    }

    .login_text {
      width: 96%;
      position: absolute;
      bottom: 19.5%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .login_text_line{
        width: 96%;
        height: 1px;
      }
      .login_text_title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 32px;
        color: #74562C;
        line-height: 50px;
        text-align: center;
        margin-bottom: 10px;
      }

      .login_text_content {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #8E6935;
        line-height: 28px;
        text-align: center;
        margin-top: 10px;

        @media (max-width: 1600px) {
          font-size: 12px;
        }
      }
    }

    // img {
    //   width: 484px;
    //   height: 440px;
    // }
  }
.card-box{
  width: 48%;
  display: flex;
  justify-content: center;
  .card-login {
    text-align: left;
    background: #fff;
    box-shadow: 2px 2px 10px 0px #DCDCDC;
    border-radius: 8px;
    padding: 40px;
    position: relative;
    width: 480px;
    height: 440px;
    .card-title{
      font-size: 36px;
      font-weight: 600;
    }
    .form_logo {
      position: absolute;
      top: -90px;
      width: 180px;
      left: 50%;
      transform: translateX(-50%);
    }

    .card-body {
      margin-top: 40px;
      .error-text {
        color: @error-color;
        margin: -2px 0 12px 0;
      }

      .login-form-forgot {
        font-size: 12px;
        font-weight: 500;
        color: #BA8438;
        text-align: right;

        span {
          cursor: pointer;
        }
      }

      .code-src {
        margin: 0 18px 0 36px;
        height: 30px;
        cursor: pointer;
      }
    }
  }
}

  .keep-record {
    text-align: center;
    color: #9c9d9c;
    padding-top: 128px;

    a {
      color: #9c9d9c;
    }

    a:hover {
      text-decoration: underline;
    }
  }
}

#login::-webkit-scrollbar {
  display: none;
}

@media (max-width: 768px) {
  #login {
    font-size: 16px;
    .card-box{
      width: 100%;
    }
    .login-swiper {
      display: none;
    }
    .card-login {
      margin-left: 5%;
      margin-right: 5%;
    }
    .layout-header {
      top: 10px;
      right: 10px;
    }
  }
}
</style>
